import React , { useEffect, useState } from "react"
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import bankServices from "../services/bankServices";
import CreateBankAccountModal from "./modals/createBankAccount";
import ConfirmBankAccountModal from "./modals/confirmBankAccountModel";
import { useSnackbar } from "notistack";
import {
  Button,
  Dialog,
  Stack,
  TextField,
  Box,
  Typography,
  Divider,
  MenuItem,
  FormControl,
  FormHelperText,
  Select,
  InputLabel
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormFileField from "./form/formFileField";
import Label from "../components/label";
// import FormSelect from "./form/formSelect";

const FormSelect = ({ label, options = [], props = {} }) => {
  return (
    <FormControl fullWidth error={props.error}>
      <InputLabel>{label}</InputLabel>
      <Select
        {...props}
        displayEmpty
        label={label}
      >
        {/* <MenuItem value="">
          <Typography variant="placeHolder" color="text.disabled">
            Select
          </Typography>
        </MenuItem> */}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Typography variant="placeHolder">{option.label}</Typography>
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{props.helperText}</FormHelperText>
    </FormControl>
  );
};

const VALID_FILE_SIZE = 5000000;
const SUPPORTED_FORMATS = ["image/png", "image/jpeg", "image/jpg","image/webp" ];

export const ManualKYCForm = ({
  open,
  setOpen,
  panCardNumber,
  entityId,
  entityType,
  getBankAccountOfEntity,
  editData = {},
  url
}) =>{

  const { enqueueSnackbar } = useSnackbar();
  const [bankChequeImage, setbankChequeImage] = useState("");
  

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  useEffect(()=>{
     if(Array.isArray(editData?.documents) && editData.documents[0]?.docUrl){
       setbankChequeImage(url + editData?.documents[0]?.docUrl)
     }
  },[])
  

  const kycSchema = Yup.object().shape({
          bankAccNumber:Yup.string()
                  .required("Account Number is required.")
                  .matches(/^\d+$/, "Account Number must be digits only.")
                  .min(6, "Account Number must be at least 6 digits.")
                  .max(18, "Account Number must be at most 18 digits."),
          ifscCode: Yup.string()
                  .required("IFSC code is required.")
                  .matches(/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/i, "Enter a valid IFSC code"),
          accHolderName: Yup.string().required("Account Holder Name is required."),
          // bankName: Yup.string().required("Bank Name is required."),
          accType: Yup.string().required("Account Type is required."),
          bankCheque: Yup.mixed()
                  .nullable()
                  .test("IS_FILE_OR_STRING", "Please upload this document.", value => {
                      if (!value) return false;
                      if (!(value instanceof File)) return true; // Skip if it's a string (existing file URL)
                      return true;
                  })
                  .test("FILE_SIZE", "Upload a file below 5MB.", value => {
                      if (!value || !(value instanceof File)) return true;
                      return value.size <= VALID_FILE_SIZE;
                  })
                  .test("FILE_FORMAT", "Uploaded file has unsupported format.", value => {
                      if (!value || !(value instanceof File)) return true;
                      return SUPPORTED_FORMATS.includes(value.type);
                  }),
      })
     
      const [validation, setValidation] = React.useState(kycSchema);
      

  const formik = useFormik({
          initialValues: {
          bankAccNumber: editData?.accountNumber || "",   
          ifscCode: editData?.ifsc||""  ,        
          accHolderName: editData?.accHolderName||""   ,  
          bankName: editData?.bankName||""  ,      
          accType: editData?.accountType||""  ,       
          bankCheque: editData?.documents?.find(doc => doc.docName === "Bank Cheque")?.docUrl
          ? { name: editData?.documents?.find(doc => doc.docName === "Bank Cheque").docUrl }
          : null, 
                                
         },
          enableReinitialize: true,
          validationSchema: validation,

          onSubmit: async (values, { resetForm }) => {
      try {
        const payload = {
          ...values,
          // panCardNumber,
          entityId,
          entityType,
          isManual:true
        };

         const formData = new FormData();
        formData.append("entityId", entityId);
        formData.append("entityType", entityType);
        formData.append("isManual", "true");
        formData.append("bankAccNumber", values.bankAccNumber);
        formData.append("ifscCode", values.ifscCode);
        formData.append("accHolderName", values.accHolderName);
        formData.append("bankName", values.bankName);
        formData.append("accType", values.accType);

        // Only append file if it's a File instance
        if (values.bankCheque instanceof File) {
          formData.append("bankCheque", values.bankCheque);
        }

        let message = ""
        let res = {}
        if(Object.keys(editData).length>0){
          res = await bankServices.updateBankAccount(editData?._id,formData);
          message = "Bank account updated successfully"
        }
        else{
           console.log(formData)
           formData.append("isManual" , true) 
           res = await bankServices.createBankAccount(formData);
           message = res?.message||"Bank Account Created Successfully"

        }
        if (res && res.success) {
          enqueueSnackbar(res?.message||message, {
            variant: "success",
          });
          getBankAccountOfEntity();
          resetForm();
          handleClose();
        } else {
          enqueueSnackbar(res?.data?.message || "Something went wrong", {
            variant: "error",
          });

          
        }
      } catch (error) {
        enqueueSnackbar("Something went wrong", { variant: "error" });
      }
    },
          
      });

      const { errors, touched, getFieldProps, values, setFieldValue, setSubmitting  } = formik;

  

      const accTypeOptions = [
        {
            label: "Current account",
            value: "Current account",
        },
        {
            label: "Saving account",
            value: "Saving account",
        },
    ]
  

  return <>

  <FormikProvider value={formik}  >
      <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit} >
          <Stack direction={"row"} justifyContent={"space-between"}>
          <Box padding={1} >
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Add New Bank Account
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Stack spacing={3}>
        <Stack direction="row" spacing={2}>
        <TextField
          label="Account Number"
          name="bankAccNumber"
          fullWidth
          value={formik.values.bankAccNumber}
          onChange={formik.handleChange}
          error={Boolean(formik.touched.bankAccNumber && formik.errors.bankAccNumber)}
          helperText={formik.touched.bankAccNumber && formik.errors.bankAccNumber}
          onBlur={formik.handleBlur}
        />

        <TextField
          label="IFSC Code"
          name="ifscCode"
          fullWidth
          value={formik.values.ifscCode}
          onChange={formik.handleChange}
          error={Boolean(formik.touched.ifscCode && formik.errors.ifscCode)}
          helperText={formik.touched.ifscCode && formik.errors.ifscCode}
          onBlur={formik.handleBlur}
        />

        </Stack>
        <Stack direction="row" spacing={2}>

        <TextField
            label="Account Holder Name"
            name="accHolderName"
            fullWidth
            value={formik.values.accHolderName}
            onChange={formik.handleChange}
            error={Boolean(formik.touched.accHolderName && formik.errors.accHolderName)}
            helperText={formik.touched.accHolderName && formik.errors.accHolderName}
            onBlur={formik.handleBlur}
        />

      <FormSelect
           label={"Account Type *"}
          options={accTypeOptions}
          sx={{marginTop : "-20px"}}
          props={{
              ...getFieldProps("accType"),
              error: Boolean(
                  touched.accType &&
                  errors?.accType
              ),
              helperText:
                  touched?.accType &&
                  errors?.accType,
          }}
      />
        </Stack>
        
      </Stack>

      <Stack
          spacing={2}
      >
          {/* <FormSelect 
              label={"Bank *"}
              options={[]} 
          /> */}
          
      <FormFileField
          label={"Cancelled Cheque Image*"}
          inputProps={{
              error: Boolean(touched.bankCheque && errors.bankCheque),
              helperText: touched.bankCheque && errors.bankCheque,
              value: values.bankCheque,
              onChange: (file) => setFieldValue("bankCheque", file),
          }}
      />

      {bankChequeImage && (
        <Box
        style={{
            width: "auto",
            height: "130px",
            border: "1px solid rgb(183 183 183)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "6px",
            marginTop: "8px",
        }}>

        <img
            src={bankChequeImage}
            alt="Selected Image"
            style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "cover",
            }}
        />
        </Box>
    )}
      </Stack>

      <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          loading={formik.isSubmitting}
          type="submit"
          variant="contained"
          sx={{ mt: 5, width: { md: "auto", xs: "100%" } }}
          // onClick={submitKyc}
        >
          Submit
        </LoadingButton>
      </Stack>
    </Box>
          </Stack>
        </Form>
  </FormikProvider>   
  </>
}
